import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import FileIcon from '@mui/icons-material/FileOpen';
import '../assets/styles/Main.scss';
import portrait from '../assets/images/profile_picture_bg_removed.png';
import CV from '../assets/documents/cv_homepage.pdf';

import React from "react";

function Main({mode}:{mode: 'dark' | 'light'}) {

  return (
    <div className="container" id="home">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={portrait} alt="Martin Stecher" className="portrait" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href={CV} target="_blank" rel="noreferrer" aria-label="CV"><FileIcon/></a>
            <a href="https://www.linkedin.com/in/martin-stecher-3408a3195/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><LinkedInIcon/></a>
            <a href="mailto:stecherm01@gmail.com" target="_blank" rel="noreferrer" aria-label="Email"><EmailIcon/></a>
          </div>
          <p className="eyebrow">Quantitative Finance · Systematic Strategies</p>
          <h1>Martin Stecher</h1>
          <h2>Quantitative Researcher &amp; Portfolio Manager</h2>
          <p className="lead">
            I build systematic fixed income strategies at Aquila Asset Management and
            manage multi-asset quant portfolios at PMP Zurich — spanning the full research
            cycle from signal generation to production. Grounded in a physics &amp; engineering
            research background at ETH Zurich and the University of Cambridge.
          </p>
          <p className="languages">
            <span>German</span><span>English</span><span>French</span><span>Spanish</span>
          </p>
          <div className="mobile_social_icons">
            <a href={CV} target="_blank" rel="noreferrer" aria-label="CV"><FileIcon/></a>
            <a href="https://www.linkedin.com/in/martin-stecher-3408a3195/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><LinkedInIcon/></a>
            <a href="mailto:stecherm01@gmail.com" target="_blank" rel="noreferrer" aria-label="Email"><EmailIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
